import React, { useState, useEffect, useRef } from "react"
import { useNavigate, useOutletContext } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import Index from "../view/WishList/Index";
import { useDispatch, useSelector } from "react-redux";
import { setLogout } from "../redux/user/user.action";
import ApiCall from "../common/ApiCall";
import HomeIcon from "../components/Iocns/HomeIcon";
import { getSlugByLang } from "../common/Helper";


export default function WishListController() {

    const [setBreadcrumbList] = useOutletContext();
    const [productList, setProductList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [limit, setLimit] = useState(5);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userLang = getSlugByLang(user?.language)
    const getProducts = async () => {
        setIsLoading(true)
        let data = {}
        data.page = currentPage
        data.limit = limit
        const recordList = await ApiCall('post', 'wish-list', data, user.token)
        setIsLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {
                setProductList(recordList.data.data)
                setTotalPages(recordList.data.last_page);
                setTotalItems(recordList.data.total)

            } else {
                if (recordList?.data?.message == 'Unauthorized' || recordList?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + userLang +'/login')
                } else {
                    // navigate(-1)
                }
            }
        }
    };

    const onPageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(() => {
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: '/' + userLang
            },
            {
                name: "Favourites"
            },
        ])
    }, [user?.language]);

    const toggleLike = async (id) => {
        setIsLoading(true)
        let data = {};
        data.product_id = id
        const likeUnlikeProduct = await ApiCall('post', 'toggle-product-like', data, user.token)
        if (likeUnlikeProduct) {

            if (likeUnlikeProduct?.data?.success) {
                await getProducts()
                setIsLoading(false)
            } else {
                if (likeUnlikeProduct?.data?.message == 'Unauthorized' || likeUnlikeProduct?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + userLang +'/login')
                }
            }
        }

    }

    useEffect(() => {

        (async () => {
            await getProducts()
        })();
    }, [currentPage]);

      useEffect(() => {
            // Check if the script is already loaded to avoid loading it multiple times
    
            const script = document.createElement('script');
            script.src = 'https://cdn.trustindex.io/loader.js';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
    
            // Cleanup: Remove the script when the component is unmounted
            return () => {
                document.head.removeChild(script);
            };
        }, [productList]);


    return (
        <>
            <PageTitle title="Profile" />

            <Index
                currentPage={currentPage}
                productList={productList}
                isLoading={isLoading}
                totalItems={totalItems}
                totalPages={totalPages}
                onPageChange={onPageChange}
                toggleLike={toggleLike}

            />
        </>
    )
}